import React from 'react'
import moment from 'moment'
import * as modalActions from 'actions/modalActions'
import * as logActions from 'actions/logActions'
import getXtractError from 'Helper/getXtractError'
import { put, select } from 'redux-saga/effects'
import StandardModalContent from 'GeneralUI/StandardModalContent/StandardModalContent.jsx'

// Note, more details on gen2's handling of api calls and callbacks can be found
// at https://github.com/XtractSolutions/Gen2_XIS/wiki/xtractAPI_documentation

/**
 * This file contains functions referenced by other sagas
 */

/**
 * displays error popup with messages defined in data/xtractError.js
 */
export function * throwXtractError(action) {
  // get the error object for the provided code
  const error = getXtractError(action.code)
  // define the content of the error window
  const errorDetails = () => {
    return (
      <div>
        <div>{error.user_message}</div>
        <div>
          {error.code && error.code.startsWith('C')
            // if its a config error (C) we can likely fix the config
            ? 'This can likely be immediately resolved by Xtract Support. Please reference the error code below.'
            // If its anything else, don't give hope of an immediate fix.
            : 'Please report this error to support and reference the error code below.'
          }
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            paddingTop: '20px',
            paddingBottom: '20px'
          }}
        >
          <div>{moment().format('YYYY-MM-DD hh:mm:ss')}</div>
          <div>{`Error code: ${error.code}`}</div>
        </div>
      </div>
    )
  }
  const username = yield select(state => {
    const { auth = {} } = state
    const { username = null } = auth
    return username
  })
  // add details to the clicklog for support to find
  const logEntry = {
    username,
    event: `error: ${error.code}`,
    patient_id: null,
    prescription_id: null,
    timestamp: moment().format('YYYY-MM-DD hh:mm:ss')
  }

  yield put(logActions.addToClickLog(logEntry))

  // dispatch an action to show the modal with the error message
  yield put(
    modalActions.openModal(
      () => null, // might have many of these, not sure were to save ids yet.
      {
        title: 'System error detected.',
        content: (
          <StandardModalContent
            messageContent={errorDetails()}
            okHandler={() => null}
            okText={'OK'}
          />
        ),
        closeable: true
      }
    )
  )
}
